import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';

import { MyApp } from './app.component';

import { ConfigApp } from "../providers/config.app";
import { ToastService } from "../services/toast-service";
import { ServerService } from "../services/server-service";
import { HomePage } from '../pages/home/home';
// import { LoginPage } from '../pages/login/login';

import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { HttpClientModule, HttpClient } from '@angular/common/http';
import { HttpModule } from "@angular/http";
import { BarcodeScanner } from '@ionic-native/barcode-scanner';
import { AndroidPermissions } from '@ionic-native/android-permissions';
// import { EventticketsPage } from '../pages/eventtickets/eventtickets';
import { AppVersion } from '@ionic-native/app-version';
import { Network } from '@ionic-native/network';
import { InAppBrowser } from '@ionic-native/in-app-browser';

import { File } from '@ionic-native/file';
import { Camera } from "@ionic-native/camera";
import { FilePath } from "@ionic-native/file-path";
import { FileTransfer } from "@ionic-native/file-transfer";

import { Ng2GoogleChartsModule } from 'ng2-google-charts';

import { Keyboard } from '@ionic-native/keyboard';

import { OpenNativeSettings } from '@ionic-native/open-native-settings';

import { LocalNotifications } from '@ionic-native/local-notifications';
import { ComponentsModule } from '../components/components.module';


@NgModule({
  declarations: [
    MyApp,
    HomePage,
    // LoginPage,
    // EventticketsPage,
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    HttpModule,
    Ng2GoogleChartsModule,
    ComponentsModule,
    IonicModule.forRoot(MyApp, {
      backButtonText: 'חזרה',
      iconMode: 'ios',
      modalEnter: 'modal-slide-in',
      modalLeave: 'modal-slide-out',
      tabsPlacement: 'bottom',
      pageTransition: 'ios-transition',
    }),
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    // LoginPage,
    // EventticketsPage,
  ],
  providers: [
    StatusBar,
    SplashScreen,
    ConfigApp,
    ToastService,
    ServerService,
    BarcodeScanner,
    AndroidPermissions,
    AppVersion,
    Network,
    InAppBrowser,
    FileTransfer,
    FilePath,
    File,
    Camera,
    Keyboard,
    OpenNativeSettings,
    LocalNotifications,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
  ]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts